<template>
  <v-container fluid>
    <div style="text-align: center" class="display-1 font-weight-thin">
      Solicitação de Pagamento para Reembolso
    </div>

    <v-snackbar auto-height v-model="snackbar.ativo" :timeout="snackbar.timeout" top right :color="snackbar.color">{{
      snackbar.text }}</v-snackbar>

    <v-layout row wrap>
      <v-flex xs12 style="height: 100%" v-if="solicitacaoDeReembolso.motivoDaReprovacao != ''">
        <v-container style="padding-bottom: 0px">
          <v-toolbar class="red lighten-1">
            <v-toolbar-title class="white--text">Motivo reprovação</v-toolbar-title>
          </v-toolbar>

          <v-content class="red lighten-2">
            <v-form>
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-textarea label="Reprovação" prepend-icon="note" v-model="solicitacaoDeReembolso.motivoDaReprovacao"
                    readonly></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>
        </v-container>
      </v-flex>

      <v-flex xs12 style="height: 100%">
        <v-container class="pt-3">
          <integracao-mensagem :mensagemIntegracao="solicitacaoDeReembolso.mensagemIntegracao"
            :statusIntegracao="solicitacaoDeReembolso.statusIntegracao"
            @chamaFuncao="prepararRequest('APROVAR')"></integracao-mensagem>

          <v-toolbar class="blue-grey lighten-4 elevation-2">
            <v-toolbar-title>Dados Gerais</v-toolbar-title>
          </v-toolbar>
          <v-content class="grey lighten-4">
            <v-form v-model="validacaoDadosGerais" ref="formDadosGerais">
              <v-layout row wrap>
                <v-flex md4 xs4>
                  <v-autocomplete label="Selecione a Empresa" append-icon="business_center"
                    v-model="solicitacaoDeReembolso.idDaEmpresa" :loading="loadingCompanies" :items="empresas.content"
                    item-value="id" item-text="nome" :rules="regraEmpresa" :readonly="!podeEditar"
                    :disabled="solicitacaoDeReembolso.despesas.length >= 1">
                    <template slot="selection" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="item" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="no-data">
                      <div class="noDataSlot">Nenhuma empresa cadastrada</div>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex md4 xs4>
                  <v-text-field label="Número do Pedido" v-model="solicitacaoDeReembolso.numeroDoPedido"
                    :rules="regraNumeroDoPedido" :readonly="!podeEditar && !verificaPerfilFinanceiro"></v-text-field>
                </v-flex>

                <v-flex md4 xs4>
                  <c-seletor-data nomeDoCampo="Data de Vencimento" :data="solicitacaoDeReembolso.vencimento"
                    :regras="regraDataVencimento" :ehEditavel="!podeEditar && !verificaPerfilFinanceiro"
                    @pegarData="(dataInserida) => solicitacaoDeReembolso.vencimento = dataInserida"
                    @validacaoFormulario="(formularioValidado) => validacaoSeletorData = formularioValidado">
                  </c-seletor-data>
                </v-flex>

                <v-flex md12 xs12>
                  <v-textarea label="Finalidade" prepend-icon="note" v-model="solicitacaoDeReembolso.finalidade"
                    :readonly="!podeEditar" :rules="finalidadeRules" class="mb-2"></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>

          <!-- Componente de Despesas estará localizado aqui -->
          <v-divider class="mx-6 my-2" inset dark></v-divider>
          <component-despesas :despesasCadastradas="solicitacaoDeReembolso.despesas" :podeEditar="podeEditar"
            :ehAprovador="ehAprovador" :idDaEmpresa="solicitacaoDeReembolso.idDaEmpresa"
            @passaValorTotal="receberTotal($event)"
            @gastos="solicitacaoDeReembolso.despesas = $event"></component-despesas>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <v-content class="grey lighten-4">
            <v-toolbar class="blue-grey lighten-4 elevation-2">
              <v-toolbar-title>Anexos</v-toolbar-title>
            </v-toolbar>
            <v-layout row wrap style="padding: 25px">
              <v-flex md12 xs12 class="text-xs-center">
                <i>Documentos fiscais que não são eletrônicos devem constar
                  cópia em anexo e via original para ser entregue no
                  financeiro</i>
              </v-flex>
              <v-layout row wrap justify-center>
                <v-flex xs9>
                  <div class="text-xs-center" v-if="solicitacaoDeReembolso.uploads.length > 0 &&
                    solicitacaoDeReembolso.status != ''
                  ">
                    <div style="height: 40px !important" v-for="(upload, index) in solicitacaoDeReembolso.uploads"
                      :key="upload.id">
                      <a target="_blank" :href="urlParaUpload + `/uploads/${upload.nomeDoArquivo}`
                        ">{{ upload.nomeDoArquivo.split(/-(.+)/)[1] }}</a>
                      <v-btn @click.prevent="
                        solicitacaoDeReembolso.uploads.splice(index, 1)
                        " color="red" flat small style="
                          padding-left: 0px;
                          margin-left: 0px;
                        " v-if="verificaAnexoContabilidade || verificaPerfilFinanceiro">
                        <v-icon>delete</v-icon>Remover
                      </v-btn>
                    </div>
                  </div>
                  <v-list class="blue-grey lighten-5" v-if="verificaAnexoContabilidade || verificaPerfilFinanceiro">
                    <v-subheader>Novos Arquivos Anexados:
                      {{ arquivoAnexado.length }}</v-subheader>
                    <v-divider color="#F0F0F0"></v-divider>
                    <v-list-tile v-for="(itemAnexado, index) in arquivoAnexado">
                      <v-list-tile-title style="height: auto !important">
                        {{ Number(index) + 1 }} - {{ itemAnexado.name }}
                        <v-btn @click.prevent="arquivoAnexado.splice(index, 1)" color="red" flat small style="
                            padding-left: 0px;
                            margin-left: 0px;
                            float: right;
                          ">
                          <v-icon>delete</v-icon>Remover
                        </v-btn>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                  <div class="text-xs-center" v-if="verificaAnexoContabilidade || verificaPerfilFinanceiro">
                    <input accept="image/jpeg, image/png, application/pdf" style="display: none" type="file" ref="files"
                      multiple @change="upload('files')" />
                    <v-btn class="white--text" color="#005ca3" @click="enviarArquivoClique()">Anexar Arquivo</v-btn>
                  </div>
                  <div v-if="msgErroAnexo != ''" class="text-xs-center mb-2">
                    <span style="color: red">{{ msgErroAnexo }}</span>
                  </div>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <c-box-fornecedor @receberBusca="solicitacaoDeReembolso.cnpj_cpf = $event"
            @receberFornecedor="receberFornecedor($event)" :fornecedorRecebido="fornecedorRecebido"
            :podeEditar="podeEditar"></c-box-fornecedor>

          <v-divider class="mx-6 my-2" inset dark></v-divider>
          <v-content v-if="solicitacaoDeReembolso.observacao != '' || ehAprovador">
            <v-toolbar class="yellow lighten-3">
              <v-toolbar-title>Observações</v-toolbar-title>
            </v-toolbar>

            <v-content class="yellow lighten-4">
              <v-form>
                <v-layout row wrap>
                  <v-flex md12 xs12>
                    <v-textarea v-model="solicitacaoDeReembolso.observacao" name="name" prepend-icon="note"
                      :readonly="!ehAprovador || !podeVisualizar()"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-content>
          </v-content>

          <!-- operações do solicitante -->
          <v-card-actions v-if="podeEditar">
            <v-spacer></v-spacer>
            <v-btn style="font-weight: bold" color="indigo darken-4" flat :loading="loadingRequest"
              @click.native="validarExcecao()" :disabled="!passouNasRegrasDeValidacao || !validacaoSeletorData">Enviar
              para aprovação</v-btn>
          </v-card-actions>
          <v-dialog @keydown.esc="dialogoAprovador = false" v-model="dialogoAprovador" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Selecione um aprovador</span>
              </v-card-title>

              <v-card-text>
                <v-form onsubmit="return false;">
                  <v-autocomplete label="Selecione um aprovador" v-model="aprovadorSelecionado"
                    :loading="loadingAprovador" :items="aprovadores" item-text="nome" item-value="id">
                    <template slot="no-data">
                      <div class="noDataSlot">Nenhum aprovador encontrado.</div>
                    </template>
                  </v-autocomplete>
                </v-form>
              </v-card-text>

              <v-card-actions style="background-color: #fff">
                <v-spacer></v-spacer>
                <v-btn color="pink" flat v-if="!loadingRequest" @click.native="fechar">Cancelar</v-btn>

                <v-progress-circular indeterminate color="blue" v-if="loadingRequest"></v-progress-circular>

                <v-btn color="indigo darken-4" flat v-if="!loadingRequest"
                  @click.native="prepararRequest('ENVIAR_PARA_APROVACAO')"
                  :disabled="!aprovadorSelecionado">Enviar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- operações para aprovadores -->
          <v-card-actions v-if="ehAprovador && podeVisualizar()">
            <v-spacer></v-spacer>

            <v-progress-circular indeterminate color="blue" v-if="loadingRequest"></v-progress-circular>

            <v-btn color="error" :disabled="loadingRequest"
              @click.native="dialogConfirmarReprovacao = true">Reprovar</v-btn>

            <v-btn color="success" v-if="solicitacaoDeReembolso.status != 'APROVADO_PELO_PROCURADOR'"
              @click.native="conferirExcecao()" :disabled="loadingRequest">Aprovar</v-btn>
          </v-card-actions>
          <v-dialog @keydown.esc="dialogConfirmarReprovacao = false" v-model="dialogConfirmarReprovacao"
            max-width="500px">
            <v-card style="background-color: #eceff1">
              <v-card-title class="error">
                <span class="mx-auto text-center" style="font-size: 1.4em; color: white">Digite o motivo da
                  reprovação</span>
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-textarea background-color="#cfd8dc" color="error"
                    v-model="solicitacaoDeReembolso.motivoDaReprovacao"></v-textarea>
                </v-form>
                <v-layout row wrap>
                  <v-btn color="error" class="ml-0" @click="dialogConfirmarReprovacao = false">Cancelar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="mr-0" @click="prepararRequest('REPROVAR')">Reprovar</v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog @keydown.esc="dialogConfirmarAprovacao = false" v-model="dialogConfirmarAprovacao" max-width="500px">
            <v-card style="background-color: #005ca3">
              <v-card-title primary-title class="pb-0">
                <p class="title font-weight-medium text-center mx-auto"
                  style="color: white; text-align: center !important">
                  {{ msgExcecao }}
                </p>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-layout row wrap v-if="this.solicitacaoDeReembolso.status !=
                  'REPROVADO_PELO_PROCURADOR'
                " class="pb-2">
                  <v-btn color="white" class="ml-5" @click="dialogConfirmarAprovacao = false">Não</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="mr-5" @click="prepararRequest('APROVAR')">Sim</v-btn>
                </v-layout>

                <v-layout row wrap class="pb-2" v-else>
                  <v-btn color="white" class="ml-5"
                    @click="prepararRequest('ENVIADO_PARA_CONTABILIDADE')">Contabilidade</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="mr-5" @click="prepararRequest('ENVIADO_PARA_PROCURADOR')">Procurador</v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogExcecao" max-width="500px">
            <v-card color="info">
              <v-card-title>
                <span class="text-xs-center" style="font-size: 1.2em; color: white">{{ msgExcecao }}</span>
              </v-card-title>
              <v-card-text class="pt-1">
                <div class="text-xs-center">
                  <v-btn style="font-weight: bold" color="white" @click.native="() => {
                    dialogExcecao = false;
                  }
                    ">Não</v-btn>
                  <v-btn style="font-weight: bold" color="white" @click.native="() => {
                    dialogExcecao = false;
                    buscarAprovadores();
                  }
                    ">Sim</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <logs-pedidos class="mt-3" v-if="solicitacaoDeReembolso.logs != null"
            :logs="solicitacaoDeReembolso.logs"></logs-pedidos>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Despesas from "@/components/solicitacao/Despesas.vue";
import LogsPedidos from "@/components/solicitacao/LogsPedidos.vue";
import BoxFornecedor from "@/components/solicitacao/BoxFornecedor.vue";
import axios from "axios";
import IntegracaoMensagem from "@/components/shared/IntegracaoMensagem.vue";
import moment from "moment";
import { feriados, converterLogParaHorarioDeSaoPaulo } from "@/mixins/dateMixin.js";
import business from "moment-business";
import debounceMixin from "@/mixins/debounceMixin";
import SeletorData from "../../shared/SeletorData";
import { validarSeUsuarioLogadoPodeVerPedido } from "@/mixins/visualizacaoPedidos.js";

export default {
  data() {
    return {
      dialogExcecao: false,
      msgExcecao: "",
      urlParaUpload: process.env.VUE_APP_API_BACKEND,
      msgErroAnexo: "",
      loadingBusca: false,
      validacaoDadosGerais: false,
      podeEditar: true,
      usuarioLogado: null,
      ehAprovador: false,
      finalidadeRules: [
        // Desculpe por isso meu eu do futuro :(
        (finalidade) => {
          if (finalidade.length <= 10) {
            return "Finalidade deve ter no mínimo 10 caracteres."
          }
          if (finalidade.length > 255) {
            return `Finalidade excedeu o limite de caracteres. 
            O número máximo permitido é de 255 caracteres`
          }
        }
      ],
      solicitacaoDeReembolso: {
        vencimento: "",
        idDoSolicitante: null,
        idDoAprovador: null,
        idDaEmpresa: null,
        numeroDoPedido: null,
        total: 0,
        finalidade: "",
        favorecido: "",
        cnpj_cpf: "",
        tipoDeMoeda: "BRL",
        despesas: [],
        uploads: [],
        pagamento: {
          conta: {
            id: null,
          },
        },
        observacao: "",
        motivoDaReprovacao: "",
        status: "",
        idDoFornecedor: null,
      },
      arquivoAnexado: "",
      loadingRequest: false,
      dialogoAprovador: false,
      loadingAprovador: false,
      aprovadores: [],
      aprovadorSelecionado: "",
      dialogConfirmarAprovacao: false,
      dialogConfirmarReprovacao: false,
      regraEmpresa: [
        (empresa) => !!empresa || "A seleção de uma empresa é obrigatória.",
      ],
      regraNumeroDoPedido: [
        numero => !!numero || "Número de pedido é obrigatório.",
        numero => isNaN(numero) ? "Este campo só pode conter números" : true
      ],
      fornecedorRecebido: {},
      snackbar: {
        ativo: false,
        timeout: 6000,
        text: "Salvo com successo!",
      },
      validacaoSeletorData: false,
      regraDataVencimento: [data => {
        if (data == "Invalid date") return "Data de vencimento é obrigatória"
        else return data.length >= 8 || "Digite uma data válida."
      }],
    };
  },
  components: {
    componentDespesas: Despesas,
    LogsPedidos,
    IntegracaoMensagem,
    "c-box-fornecedor": BoxFornecedor,
    "c-seletor-data": SeletorData
  },
  computed: {
    retornaTextoCorretoParaFinanceiro() {
      if (this.solicitacaoDeReembolso.status == "REPROVADO_PELO_PROCURADOR")
        return "Para quem deseja enviar?";
      else return "Confirmar aprovação do pedido?";
    },
    verificaPerfilFinanceiro() {
      if (
        this.usuarioAutenticado.papeis.filter(
          (papel) => papel.nome === "APROVADOR_FINANCEIRO"
        ).length != 0 &&
        (this.solicitacaoDeReembolso.status == "ENVIADO_PARA_FINANCEIRO" ||
          this.solicitacaoDeReembolso.status == "REPROVADO_PELO_PROCURADOR")
      ) {
        return true;
      } else return false;
    },
    empresas() {
      return this.$store.getters.empresas;
    },
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    },
    loadingCompanies() {
      return this.$store.getters.loadingCompanies;
    },
    passouNasRegrasDeValidacao() {
      if (
        this.validacaoDadosGerais &&
        this.solicitacaoDeReembolso.favorecido != "" &&
        this.solicitacaoDeReembolso.despesas.length > 0 &&
        (this.arquivoAnexado.length > 0 ||
          this.solicitacaoDeReembolso.uploads.length > 0)
      )
        return true;
      else return false;
    },
    verificaAnexoContabilidade() {
      if (
        this.usuarioLogado.papeis.filter(
          (papel) => papel.nome === "APROVADOR_CONTABILIDADE"
        ).length != 0 &&
        this.solicitacaoDeReembolso.status == "ENVIADO_PARA_CONTABILIDADE"
      ) {
        return true;
      } else if (this.podeEditar) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    conferirExcecao() {
      if (this.solicitacaoDeReembolso.status == "ENVIADO_PARA_GESTOR") {
        this.solicitacaoDeReembolso.excecao = this.retornaExcecao(
          "dialogConfirmarAprovacao"
        );
      } else {
        this.dialogConfirmarAprovacao = true;
        this.msgExcecao = this.retornaTextoCorretoParaFinanceiro;
      }
    },
    retornaExcecao(dialogParaAbrir) {
      const range = this.calculaRangeDeData(
        this.solicitacaoDeReembolso.vencimento
      );
      if (range < 5) {
        this[dialogParaAbrir] = true;
        if (range < 0)
          this.msgExcecao =
            "Atenção! Documento vencido, deseja continuar? \n (Antes de enviar ao financeiro contate seu fornecedor para negociar uma nova data de pagamento!)";
        else
          this.msgExcecao =
            "Atenção! Pagamento fora do prazo de cinco dias úteis antes do vencimento, deseja continuar? \n (Antes de enviar ao financeiro contate seu fornecedor para negociar uma nova data de pagamento!)";
        return true;
      } else {
        this[dialogParaAbrir] = true;
        this.msgExcecao = this.retornaTextoCorretoParaFinanceiro;
        return false;
      }
    },
    receberTotal(total) {
      this.solicitacaoDeReembolso.total = total;
    },
    enviarArquivoClique() {
      this.$refs.files.click();
    },
    formataStatusIntegracao(msgStatus) {
      let msgDoStatus;
      if (msgStatus) msgDoStatus = "Integrado ao sistema";
      else msgDoStatus = "Erro na Integração";
      return `${msgDoStatus}`;
    },
    podeVisualizar() {
      let idDoUsuario = this.usuarioLogado.id;
      let papeis = this.usuarioLogado.papeis;
      let solicitacao = this.solicitacaoDeReembolso;

      if (idDoUsuario != solicitacao.idDoSolicitante) {
        if (
          papeis.filter((papel) => papel.nome === "APROVADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_GESTOR"
        )
          return true;
        else if (
          papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        )
          return true;
        else if (
          papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_FINANCEIRO"
        )
          return true;
        else if (
          papeis.filter((papel) => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_CONTABILIDADE"
        )
          return true;
        else if (
          papeis.filter((papel) => papel.nome === "PROCURADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_PROCURADOR"
        )
          return true;
        else if (
          papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
          (solicitacao.status === "REPROVADO_PELO_PROCURADOR" ||
            solicitacao.status === "APROVADO_PELO_PROCURADOR")
        )
          return true;
        else return false;
      } else {
        if (
          (papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
            solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO") ||
          (papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_FINANCEIRO") ||
          (papeis.filter((papel) => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_CONTABILIDADE") ||
          (papeis.filter((papel) => papel.nome === "PROCURADOR").length > 0 &&
            solicitacao.status === "ENVIADO_PARA_PROCURADOR") ||
          (papeis.filter((papel) => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            (solicitacao.status === "REPROVADO_PELO_PROCURADOR" ||
              solicitacao.status === "APROVADO_PELO_PROCURADOR"))
        )
          return true;

        return false;
      }
    },
    async inicializa() {
      this.usuarioLogado = this.usuarioAutenticado;
      this.solicitacaoDeReembolso.idDoSolicitante = this.usuarioLogado.id;

      await this.$store.dispatch("get", {
        loaderName: "loadingCompanies",
        service: "/empresas",
        itemName: "empresas",
      });

      await this.$store.dispatch("get", {
        loaderName: "loadingManagementAccounts",
        service: "/contasgerenciais?size=50000",
        itemName: "todasAsContasGerenciais",
      });
    },
    async buscaPedidoDeReembolso(id) {
      await axios({
        method: "get",
        url: `/pedidos/reembolso/${id}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((resposta) => {
          const usuariosDoPedido = {
            idAprovador: resposta.data.idDoAprovador,
            idRegistrador: resposta.data.idDoSolicitante
          }
          if (validarSeUsuarioLogadoPodeVerPedido(usuariosDoPedido)) {
            this.solicitacaoDeReembolso = resposta.data;
            let s = this.solicitacaoDeReembolso;
            let contasBancarias = [...resposta.data.dadosBancariosDoFornecedor];

            if (this.solicitacaoDeReembolso.logs && this.solicitacaoDeReembolso.logs.length > 0) {
              this.solicitacaoDeReembolso.logs = this.solicitacaoDeReembolso.logs.map(log => converterLogParaHorarioDeSaoPaulo(log));
            }

            contasBancarias.map((c) => {
              if (s.pagamento.conta.id == c.id) c.selecionado = true;
              else c.selecionado = false;
            });
            let filtrarContasAtivas = contasBancarias.filter((c) => c.estaAtivo);
            let fornecedorComponente = {
              fornecedorDigitado: s.cnpj_cpf,
              fornecedor: {
                id: s.idDoFornecedor,
                nome: s.favorecido,
                dadosBancarios: [...filtrarContasAtivas],
              },
            };
            this.fornecedorRecebido = fornecedorComponente;
            this.configuraPermissaoParaEdicao();
          }
        })
        .catch((erro) => {
          console.error("Ocorreo um erro ao buscar pelo pedido de reembolso");
          console.error(erro);
        });
    },
    configuraPermissaoParaEdicao() {
      let usuarioEhUmAprovador =
        this.usuarioLogado.papeis.filter(
          (papel) => papel.nome.indexOf("APROVADOR") != -1
        ).length > 0;

      let usuarioEhProcurador =
        this.usuarioLogado.papeis.filter(
          (papel) => papel.nome.indexOf("PROCURADOR") != -1
        ).length > 0 &&
        this.solicitacaoDeReembolso.status == "ENVIADO_PARA_PROCURADOR";

      let mesmoAprovador =
        this.solicitacaoDeReembolso.idDoAprovador == this.usuarioLogado.id;

      if (
        this.solicitacaoDeReembolso.status == "ENVIADO_PARA_GESTOR" &&
        mesmoAprovador
      )
        this.ehAprovador = true;
      else {
        if (
          (usuarioEhUmAprovador || usuarioEhProcurador) &&
          this.solicitacaoDeReembolso.status != "ENVIADO_PARA_GESTOR"
        )
          this.ehAprovador = true;
      }

      let solicitacaoNova = this.solicitacaoDeReembolso.id === null;
      let usuarioEhSolicitante =
        this.usuarioLogado.id === this.solicitacaoDeReembolso.idDoSolicitante;
      let reembolsoFoiReprovado =
        this.solicitacaoDeReembolso.status.indexOf("REPROVADO") != -1 &&
        this.solicitacaoDeReembolso.status != "REPROVADO_PELO_PROCURADOR";

      if (solicitacaoNova || (usuarioEhSolicitante && reembolsoFoiReprovado))
        this.podeEditar = true;
      else this.podeEditar = false;
    },
    validarExcecao() {
      let pedidoEhExcecao = this.retornaExcecao("dialogExcecao");
      if (!pedidoEhExcecao) {
        this.buscarAprovadores();
      }
    },
    buscarAprovadores() {
      this.dialogoAprovador = true;
      this.loadingAprovador = true;
      axios({
        method: "get",
        url: `/usuarios/${this.usuarioLogado.id}/papel/APROVADOR`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((resposta) => {
          this.aprovadores = resposta.data;
        })
        .catch((erro) => {
          console.error("Ocorreo um erro ao buscar aprovadores");
          console.error(erro);
        });

      this.loadingAprovador = false;
    },
    fechar() {
      this.dialogoAprovador = false;
      this.aprovadorSelecionado = "";
    },
    gerenciaStatusDoReembolso(operacao) {
      // solicitante
      if (
        operacao === "ENVIAR_PARA_APROVACAO" &&
        this.usuarioLogado.papeis.filter(
          (papel) => papel.nome === "SOLICITANTE"
        ).length > 0
      ) {
        return "ENVIADO_PARA_GESTOR";
      }

      // aprovadores
      if (operacao === "APROVAR") {
        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_GESTOR"
        ) {
          if (this.solicitacaoDeReembolso.statusDoFornecedor == "EM_ANALISE") {
            return "ENVIADO_PARA_ADM_FORNECEDOR";
          } else {
            if (this.solicitacaoDeReembolso.excecao)
              return "ENVIADO_PARA_ADM_FINANCEIRO";
            else return "ENVIADO_PARA_FINANCEIRO";
          }
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        ) {
          this.solicitacaoDeReembolso.excecao = true;
          return "ENVIADO_PARA_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_FINANCEIRO"
        ) {
          return "ENVIADO_PARA_CONTABILIDADE";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "ADMIN_FORNECEDOR"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_ADM_FORNECEDOR"
        ) {
          return "ENVIADO_PARA_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "ENVIADO_PARA_PROCURADOR";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "PROCURADOR"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "APROVADO_PELO_PROCURADOR";
        }
        //Temporario
        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "REPROVADO_PELO_PROCURADOR"
        ) {
          return "ENVIADO_PARA_PROCURADOR";
        }
      }

      // reprovadores
      if (operacao === "REPROVAR") {
        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_GESTOR"
        ) {
          return "REPROVADO_PELO_GESTOR";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          (this.solicitacaoDeReembolso.status === "ENVIADO_PARA_FINANCEIRO" ||
            this.solicitacaoDeReembolso.status === "REPROVADO_PELO_PROCURADOR")
        ) {
          return "REPROVADO_PELO_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "REPROVADO_PELA_CONTABILIDADE";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "PROCURADOR"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        ) {
          return "REPROVADO_PELO_ADM_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            (papel) => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoDeReembolso.status === "APROVADO_PELO_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }
      } else return operacao;
    },
    calculaRangeDeData(data) {
      const dataFormatada = moment(data);
      const hoje = moment().startOf("day");
      const range = business.weekDays(hoje, dataFormatada);
      const feriado = feriados(data, 5);
      let diaFinal = range + feriado;
      return diaFinal;
    },
    prepararRequest(operacao) {
      this.loadingRequest = true;

      let solicitacaoCopia = Object.assign({}, this.solicitacaoDeReembolso);
      solicitacaoCopia.idAprovadorLog = this.usuarioLogado.id;

      if (operacao === "ENVIAR_PARA_APROVACAO") {
        solicitacaoCopia.idDoAprovador = this.aprovadorSelecionado;
        this.dialogoAprovador = false;
      }

      this.dialogConfirmarAprovacao = false;

      if (operacao === "REPROVAR") {
        this.dialogConfirmarReprovacao = false;
      }

      solicitacaoCopia.cnpj_cpf = solicitacaoCopia.cnpj_cpf
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      solicitacaoCopia.status = this.gerenciaStatusDoReembolso(operacao);
      solicitacaoCopia.despesas.map((item) => {
        item.rateio.valor = parseFloat(item.rateio.valor).toFixed(2);
      });

      this.fazerRequest(solicitacaoCopia);
    },
    fazerRequest(dados) {
      let vm = this;
      this.loadingRequest = true;
      let operacaoHTTP = "POST";
      if (this.solicitacaoDeReembolso.id != null) operacaoHTTP = "PUT";

      this.snackbar.ativo = true;
      this.snackbar.color = "primary";
      this.snackbar.text = "Carregando...";

      axios({
        method: `${operacaoHTTP}`,
        url: `/pedidos/reembolso`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: JSON.stringify(dados),
      })
        .then((resposta) => {
          this.snackbar.ativo = false;
          this.snackbar.color = "success";
          this.snackbar.text = "Salvo com Sucesso!";
          this.snackbar.ativo = true;

          // caso tenha anexado arquivo
          if (this.arquivoAnexado.length > 0) {
            const anexosFormData = this.converterAnexosEmFormData()
            this.salvarAnexos(resposta.data.id, anexosFormData)
          }

          setTimeout(function () {
            vm.$router.push({ name: `solicitacoes` });
          }, 2000);
        })
        .catch((erro) => {
          this.snackbar.color = "error";
          this.snackbar.text = `Houve um erro na criação / envio do pedido. Para mais informações entre em contato com o Administrador.`;
          const erroPossuiResposta = erro.response == !undefined
          if (erroPossuiResposta) {
            const codigoErro = erro.response.status;
            const ehErroIntegracao = codigoErro == 502;
            if (ehErroIntegracao) {
              this.solicitacaoDeReembolso.statusIntegracao =
                erro.response.data.statusIntegracao;
              this.solicitacaoDeReembolso.mensagemIntegracao =
                erro.response.data.mensagemIntegracao;
              this.snackbar.text = `Houve um erro na integração do pedido.`;
            }
          }
          this.loadingRequest = false;
          this.snackbar.ativo = true;
        });
    },
    receberFornecedor(event) {
      let contaCorreta = event.dadosBancarios.filter(
        (i) => i.selecionado == true
      );
      const dadosBancarios = contaCorreta[0];
      this.solicitacaoDeReembolso.dadosBancariosDoFornecedor =
        event.dadosBancarios;
      this.solicitacaoDeReembolso.pagamento.conta.id = dadosBancarios.id;
      this.solicitacaoDeReembolso.idDoFornecedor = event.id;
      this.solicitacaoDeReembolso.favorecido = event.nome;
    },
    buscaDadosBancarios() {
      this.loadingBusca = true;
      if (
        this.solicitacaoDeReembolso.cnpj_cpf == null ||
        this.solicitacaoDeReembolso.cnpj_cpf == ""
      ) {
        this.loadingBusca = false;
        return;
      }

      let numeroDocumento = this.solicitacaoDeReembolso.cnpj_cpf
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      axios({
        method: "GET",
        url: `/fornecedores/busca?fornecedor=${numeroDocumento}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((resposta) => {
          const dadosBancarios = resposta.data.dadosBancarios[0];
          this.solicitacaoDeReembolso.banco = dadosBancarios.banco;
          this.solicitacaoDeReembolso.agencia = dadosBancarios.agencia;
          this.solicitacaoDeReembolso.contaCorrente = dadosBancarios.conta;
          this.solicitacaoDeReembolso.idDoFornecedor = resposta.data.id;
          this.solicitacaoDeReembolso.favorecido = resposta.data.nome;
          this.loadingBusca = false;
        })
        .catch((erro) => {
          console.error("Ocorreu um erro ao tentar buscar por fornecedor");
          console.error(erro);
          this.solicitacaoDeReembolso.banco = "";
          this.solicitacaoDeReembolso.agencia = "";
          this.solicitacaoDeReembolso.contaCorrente = "";
          this.solicitacaoDeReembolso.idDoFornecedor = "";
          this.solicitacaoDeReembolso.favorecido = "";
          this.loadingBusca = false;
        });
    },
    upload(nome) {
      let arquivos = this.$refs[nome].files;
      let foiValidado = true;
      let nomeDoArquivo = "";
      let erroMsg = "";
      let somaNovosArquivos = 0;
      let somaTamanhoTotal = 0;

      for (let index = 0; index < arquivos.length; index++) {
        const itemArray = arquivos[index];
        if (itemArray.size >= 50000000) {
          nomeDoArquivo = itemArray.name;
          erroMsg = `O arquivo ${nomeDoArquivo} ultrapassou o tamanho máximo de 50MB de anexos.`;
          foiValidado = false;
          break;
        }
        somaNovosArquivos += itemArray.size;
      }

      for (let index = 0; index < this.arquivoAnexado.length; index++) {
        let itemJaInserido = this.arquivoAnexado[index];
        somaTamanhoTotal += this.arquivoAnexado[index].size;
      }
      if (somaNovosArquivos + somaTamanhoTotal >= 50000000) {
        erroMsg = `Limite máximo de anexo excedido. Permitido no máximo até 50MB.`;
        foiValidado = false;
      }
      if (foiValidado) {
        this.arquivoAnexado = [...this.arquivoAnexado, ...arquivos];
        this.msgErroAnexo = "";
      } else this.msgErroAnexo = erroMsg;
    },
    salvarAnexos(idPedido, anexos) {
      console.log('------SALVANDO ANEXO------')
      axios({
        method: "post",
        url: `/uploads/pedidos/${idPedido}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: anexos,
      })
        .then(() => console.log('ANEXO SALVO COM SUCESSO'))
        .catch((erro) => {
          console.log('------ERRO DE ANEXO ABAIXO------')
          console.log(erro)
          console.log(erro.response)
        })
    },
    converterAnexosEmFormData() {
      let formData = new FormData();
      for (let i = 0; i < this.arquivoAnexado.length; i++)
        formData.append("arquivos", this.arquivoAnexado[i]);

      return formData;
    }
  },
  async created() {
    await this.inicializa();

    if (this.$route.params.id !== undefined)
      await this.buscaPedidoDeReembolso(this.$route.params.id);
  },
};
</script>
<style>
.flex {
  padding: 0px 16px;
}

.noDataSlot {
  font-size: 1em;
  padding: 10px;
}
</style>